/*
This action file conatin all the actions that are related to signup process
*/
import * as api from '../api';

export const UPDATE_PLAN = 'UPDATE_PLAN';
export function handlePlan(selectedPlan) {
	return {
		type: UPDATE_PLAN,
		payload: {
			newplan: selectedPlan
		}
	};
}


export const CANCEL_POPUP = 'CANCEL_POPUP';
export function cancelPopUp(newvalue) {
	return {
		type: CANCEL_POPUP,
		payload: {
			cancel: newvalue
		}
	};
}

export const CANCEL_COMPANY_VALIDATION='CANCEL_COMPANY_VALIDATION';

export function cancelValidation(){
	return {
		type: CANCEL_COMPANY_VALIDATION
	};
}

export const ADD_COMPANY_REQUEST = 'ADD_COMPANY_REQUEST';
export const ADD_COMPANY_FAILURE = 'ADD_COMPANY_FAILURE';
export const ADD_COMPANY_SUCCESS = 'ADD_COMPANY_SUCCESS';

export function submitCompanyData(name, email, password, selected_pms, user_name,plan,otp, plan_number) {
	return function (dispatch, getState) {
		dispatch({
			type: ADD_COMPANY_REQUEST
		});
    api.addCompany(name, email, password, selected_pms, user_name, plan, otp, plan_number)
    .then(
			(response) => {
				dispatch({
					type: ADD_COMPANY_SUCCESS,
					users: response
				});
				dispatch({
		          type: 'NOTIFICATION_ADD',
		          text: 'Company and user created, please enter your card details.',
		          msgtype: 'success'
		        });
			},
			(error) => {
				if(error.then){	
					error.then((json)=>{
						dispatch({
							type: NOTIFICATION_ADD,
              text: json.errors.otp.msg || 'Company data is invalid',
							msgtype: 'danger'
						});
						dispatch({
							type: ADD_COMPANY_FAILURE,
							errors: json.errors
						});
					});
				}else{
					dispatch({
						type: ADD_COMPANY_FAILURE,
						error: error,
						message: error.message || 'Could not submit company data'
					});
				}
			}
		);
	};
};

export const VALIDATE_COMPANYDATA_REQUEST = 'VALIDATE_COMPANYDATA_REQUEST';
export const VALIDATE_COMPANYDATA_FAILURE = 'VALIDATE_COMPANYDATA_FAILURE';
export const VALIDATE_COMPANYDATA_SUCCESS = 'VALIDATE_COMPANYDATA_SUCCESS';

export function validateCompanyData(name, email, password, selected_pms, user_name,plan) {
	return function (dispatch, getState) {
		dispatch({
			type: VALIDATE_COMPANYDATA_REQUEST
		});
		api.validateCompany(name, email, password, selected_pms, user_name,plan).then(
			(response) => {
				dispatch({
					type: VALIDATE_COMPANYDATA_SUCCESS
				});
			},
			(error) => {
				if(error.then){
					dispatch({
						type: NOTIFICATION_ADD,
						text: 'Company data is invalid',
						msgtype: 'danger'
					});
					error.then((json)=>{
						dispatch({
							type: VALIDATE_COMPANYDATA_FAILURE,
							errors: json.errors
						});
					});
				}else{
					dispatch({
						type: VALIDATE_COMPANYDATA_FAILURE,
						errors: error,
						message: error.message || 'Could not submit company data'
					});
				}
			}
		);
	};
};



export const ADD_TEAM_MEMBER = 'ADD_TEAM_MEMBER';
export const ADD_TEAM_MEMBER_FAIL = 'ADD_TEAM_MEMBER_FAIL';
export const ADD_TEAM_MEMBER_SUCCESS = 'ADD_TEAM_MEMBER_SUCCESS';

export function addSelectedManual(companyid, manuals) {
	return function (dispatch, getState) {
		dispatch({
			type: ADD_TEAM_MEMBER
		});
		api.addSelectedManual(companyid, manuals).then(
			(response) => {
				dispatch({
					type: ADD_TEAM_MEMBER_SUCCESS,
					team: response
				});
				dispatch({
		          type: 'NOTIFICATION_ADD',
		          text: response.message,
		          msgtype: 'success'
		        });
			},
			(error) => {
				dispatch({
		          type: 'NOTIFICATION_ADD',
		          text: error.message || 'Could not create teams',
		          msgtype: 'danger'
		        });
				dispatch({
					type: ADD_TEAM_MEMBER_FAIL,
					error: error,
					message: error.message || 'Could not create teams'
				});
				
			}
		);
	};
};

export const ADD_CONTACT = 'ADD_CONTACT';
export const ADD_CONTACT_FAIL = 'ADD_CONTACT_FAIL';
export const ADD_CONTACT_SUCCESS = 'ADD_CONTACT_SUCCESS';

export function submitContactOther(name, email, telephone) {
	return function (dispatch, getState) {
		dispatch({
			type: ADD_CONTACT
		});
		api.contactOther(name, email, telephone).then(
			(response) => {
				dispatch({
					type: ADD_CONTACT_SUCCESS,
					contact: response
				});
			},
			(error) => {
				dispatch({
					type: ADD_CONTACT_FAIL,
					error: error,
					message: error.message || 'Could not insert record'
				});
			}
		);
	};
};

export function submitContactNone(name, email) {
	return function (dispatch, getState) {
		dispatch({
			type: ADD_CONTACT
		});
		api.contactNone(name, email).then(
			(response) => {
				dispatch({
					type: ADD_CONTACT_SUCCESS,
					contact: response
				});
			},
			(error) => {
				dispatch({
					type: ADD_CONTACT_FAIL,
					error: error,
					message: error.message || 'Could not insert record'
				});
			}
		);
	};
};

export const ADD_SIMPRO_API = 'ADD_SIMPRO_API';
export const ADD_SIMPRO_API_FAIL = 'ADD_SIMPRO_API_FAIL';
export const ADD_SIMPRO_API_SUCCESS = 'ADD_SIMPRO_API_SUCCESS';
export function addSimproApi(companyid, apikey) {
	return function (dispatch, getState) {
		dispatch({
			type: ADD_SIMPRO_API
		});
		api.addSimproApi(companyid, apikey).then(
			(response) => {
				dispatch({
					type: ADD_SIMPRO_API_SUCCESS,
					simproKey: response
				});
			},
			(error) => {
				dispatch({
					type: ADD_SIMPRO_API_FAIL,
					error: error,
					message: error.message || 'Could not verify simpro api key.'
				});
			}
		);
	};
}

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';
export function restPassword(email, password) {
	return function (dispatch, getState) {
		dispatch({
			type: RESET_PASSWORD
		});
		api.restPassword(email, password).then(
			(response) => {
				dispatch({
					type: RESET_PASSWORD_SUCCESS,
					forgatPass: response.message
				});
			},
			(error) => {
				dispatch({
					type: RESET_PASSWORD_FAIL,
					error: error,
					message: error.message || 'Could not reset password.'
				});
				dispatch({
					type: NOTIFICATION_ADD,
					text: 'Could not reset password.',
					msgtype: 'danger'
				});
			}
		);
	};
}

export const FETCH_SUBSCRIPTION_REQUEST = 'FETCH_SUBSCRIPTION_REQUEST';
export const FETCH_SUBSCRIPTION_FAILURE = 'FETCH_SUBSCRIPTION_FAILURE';
export const FETCH_SUBSCRIPTION_SUCCESS = 'FETCH_SUBSCRIPTION_SUCCESS';

export function fetchSubscription(plan) {
	
	return function (dispatch, getState) {
		dispatch({
			type: FETCH_SUBSCRIPTION_REQUEST
		});
		api.fetchSubscription(plan).then(
			(response) => {
				dispatch({
					type: FETCH_SUBSCRIPTION_SUCCESS,
					subscription: response
				});
			},
			(error) => {
				dispatch({
					type: FETCH_SUBSCRIPTION_FAILURE,
					text: 'Error fetching subscription',
					msgtype: 'danger'
				});
			}
		);
	};
}
export const API_AUTHORIZE_REQUEST = 'API_AUTHORIZE_REQUEST';
export const API_AUTHORIZE_FAILURE = 'API_AUTHORIZE_FAILURE';
export const API_AUTHORIZE_SUCCESS = 'API_AUTHORIZE_SUCCESS';

export function authorizeApi(companyid,url,simprouser,simpropass, check=false, redirectUrl) {
	
	return function (dispatch, getState) {
		dispatch({
			type: API_AUTHORIZE_REQUEST
		});
		api.authorizeApi(companyid,url,simprouser,simpropass, check, redirectUrl).then(
			(response) => {
				dispatch({
					type: API_AUTHORIZE_SUCCESS,
					apiAuthorize: response
				});
				dispatch({
					type: NOTIFICATION_ADD,
					text: 'Your authorisation is successful, Please continue to login.',
					msgtype: 'success'
				});
			},
			(error) => {
				dispatch({
					type: API_AUTHORIZE_FAILURE,
					text: 'Error authenticating request',
					msgtype: 'danger'
				});
				dispatch({
					type: NOTIFICATION_ADD,
					text: 'Your authorisation was unsuccessful.',
					msgtype: 'danger'
				});
			}
		);
	};
}


export const CHECK_COMPANIES_API_REQUEST = 'CHECK_COMPANIES_API_REQUEST';
export const CHECK_COMPANIES_API_FAILURE = 'CHECK_COMPANIES_API_FAILURE';
export const CHECK_COMPANIES_API_SUCCESS = 'CHECK_COMPANIES_API_SUCCESS';

export function checkCompaniesFromApi(companyid) {
  
  return function (dispatch, getState) {
    dispatch({
      type: CHECK_COMPANIES_API_REQUEST
    });
    api.checkCompaniesFromApi(companyid).then(
      (response) => {
        dispatch({
          type: CHECK_COMPANIES_API_SUCCESS,
          apiAuthorize: response
        });
      },
      (error) => {
        dispatch({
          type: CHECK_COMPANIES_API_FAILURE,
          text: 'Error get api companies request',
          msgtype: 'danger'
        });
      }
    );
  };
}

export const VERIFY_SIMPRO_USERPASS_REQUEST = 'VERIFY_SIMPRO_USERPASS_REQUEST';
export const VERIFY_SIMPRO_USERPASS_FAILURE = 'VERIFY_SIMPRO_USERPASS_FAILURE';
export const VERIFY_SIMPRO_USERPASS_SUCCESS = 'VERIFY_SIMPRO_USERPASS_SUCCESS';

export function verifyUserPass(url,simprouser,simpropass, companyId) {
	
	return function (dispatch, getState) {
		dispatch({
			type: VERIFY_SIMPRO_USERPASS_REQUEST
		});
		api.verifyUserPass(url,simprouser,simpropass, companyId).then(
			(response) => {
				dispatch({
					type: VERIFY_SIMPRO_USERPASS_SUCCESS,
					apiAuthorize: response
				});
				dispatch({
					type: NOTIFICATION_ADD,
					text: 'Simpro Username and Password Validated successfully',
					msgtype: 'success'
				});
			},
			(error) => {
				dispatch({
					type: VERIFY_SIMPRO_USERPASS_FAILURE,
					text: 'Error authenticating request',
					msgtype: 'danger'
				});
				dispatch({
					type: NOTIFICATION_ADD,
					text: 'Simpro Username and Password could not be verified.',
					msgtype: 'danger'
				});
			}
		);
	};
}



// WEBPACK FOOTER //
// ./src/Actions/signup.js